import { render, staticRenderFns } from "./vue-google-autocomplete.vue?vue&type=template&id=13ba3032&"
import script from "./vue-google-autocomplete.vue?vue&type=script&lang=js&"
export * from "./vue-google-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vue-google-autocomplete.vue"
export default component.exports